import { defineMessages } from 'react-intl';
var msg = defineMessages({
    customer: { defaultMessage: 'Kundendaten', id: 'customerAdd.menu.headline' },
});
export default msg;
